import { render, staticRenderFns } from "./save-audience.vue?vue&type=template&id=6676500a&scoped=true"
import script from "./save-audience.vue?vue&type=script&lang=js"
export * from "./save-audience.vue?vue&type=script&lang=js"
import style0 from "./save-audience.vue?vue&type=style&index=0&id=6676500a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6676500a",
  null
  
)

export default component.exports